import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
let redirect = 'index';
// let isMobile = localStorage.getItem("isMobile");
// if (isMobile == 'true') {
//     redirect = 'indexM';
// }

const routesC = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../components/home'),
        redirect: redirect,
        meta: { requiresAuth: true, title: '首页' },
        children: [
            {
                path: '/index',
                name: 'index',
                meta: {
                    title: "首页"
                },
                component: () => import('../views/new/index')
            },
            {
                path: '/nrPage',
                name: 'nrPage',
                meta: {
                    title: "内容网页"
                },
                component: () => import('../views/c/nrPage')
            },
            {
                path: '/singlePage',
                name: 'singlePage',
                meta: {
                    title: "单网页"
                },
                component: () => import('../views/c/singlePageNew')
            },
            {
                path: '/multiPage',
                name: 'multiPage',
                meta: {
                    title: "多网页"
                },
                component: () => import('../views/c/multiPage')
            },
            {
                path: '/classificationPage',
                name: 'classificationPage',
                meta: {
                    title: "分类网页"
                },
                component: () => import('../views/c/classificationPage')
            },
            {
                path: '/singlePageContentOnly',
                name: 'singlePageContentOnly',
                meta: {
                    title: 'Content Preview'
                },
                component: () => import('../views/c/singlePageContentOnly')
            },

        ],
    },
]

const routesM = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../components/home'),
        redirect: redirect,
        meta: { requiresAuth: true, title: '首页' },
        children: [
            {
                path: '/index',
                name: 'index',
                meta: {
                    title: "首页"
                },
                component: () => import('../views/m/indexM')
            },
            {
                path: '/nrPage',
                name: 'nrPage',
                meta: {
                    title: "内容网页"
                },
                component: () => import('../views/m/nrPageM')
            },
            {
                path: '/singlePage',
                name: 'singlePage',
                meta: {
                    title: "单网页"
                },
                component: () => import('../views/m/singlePageM')
            },
            {
                path: '/multiPage',
                name: 'multiPage',
                meta: {
                    title: "多网页"
                },
                component: () => import('../views/m/multiPageM')
            },
            {
                path: '/classificationPage',
                name: 'classificationPage',
                meta: {
                    title: "分类网页"
                },
                component: () => import('../views/m/classificationPageM')
            },
            {
                path: '/singlePageContentOnly',
                name: 'singlePageContentOnly',
                meta: {
                    title: 'Content Preview'
                },
                component: () => import('../views/c/singlePageContentOnly')
            },

        ],
    },
]

let routes = [];
const userAgent = navigator.userAgent;
const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
if (mobileRegex.test(userAgent)) {
    routes = routesM;
} else {
    routes = routesC;
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 解决上一个页面跳转然后另外一个页面不滚动的问题
router.afterEach(() => {
    window.scrollTo(0, 0);
});



export default router
